module.exports = __webpack_public_path__ + "images/lab/project-progress-5143be2f6226472ba847e7a54bd4e93d.jpg";